export default "__VITE_ASSET__DIRx75WH__"